<template>
    <div class="buble-holder-right">
        <v-dialog v-model="vistoModal" content-class="VistoModal" persistent>
            <v-card>
                <v-card-title style="display:block; text-align:center" class="justify-center primary">
                    <v-toolbar-title id="titulocard">Informaci&oacute;n Mensaje</v-toolbar-title>
                    <v-spacer></v-spacer>
                </v-card-title>
                <div class="spinner-container text-center" v-if="loadingModal">
                    <v-progress-circular indeterminate color="green"></v-progress-circular>
                </div>
                <div v-if="!loadingModal">

                    <div class="text-center text-tittle">
                        <span class="text-subtitle"> Leido Por    </span>
                        <i class="mdi mdi-check-all blue-icon"></i>
                    </div>
                    <div style="text-align: center;">


                        <div style="display: inline-block; text-align: left;">

                            <div class="borders" v-for="(item, index) in usuariosVisto" :key="index">

                                <i class="mdi mdi-account-circle" style=" font-size: 1.5em;"></i>
                                <span class="text-sup">  {{item.uslogin}}  -  </span>
                                <i class="mdi mdi-calendar-blank" style=" font-size: 1.5em;"></i>
                                <span class="text-subtitle">  {{item.bwhfhleido}} </span>



                            </div>



                        </div>



                    </div>

                </div>


                <div class="text-center btnCerrar">
                    <v-btn dark color="error" @click="vistoModal = false">
                        Cerrar
                    </v-btn>
                </div>
            </v-card>

        </v-dialog>

        <v-dialog v-model="contactModal" content-class="VistoModal" persistent>
            <v-card style="min-height: 30vh;">
                <v-card-title class="primary text-center">
                    <v-toolbar-title id="titulocard">Teléfonos</v-toolbar-title>
                </v-card-title>

                <v-card-text>
                    <v-list dense>
                        <template v-for="(contact, index) in phones">
                            <!-- Nombre del contacto -->
                            <v-list-item>
                                <v-list-item-content>
                                    <span class="font-weight-bold">{{ contact.name }}</span>
                                </v-list-item-content>
                            </v-list-item>
                            <v-divider></v-divider>

                            <!-- Teléfonos del contacto -->
                            <template v-for="(phone, idx) in contact.phones">
                                <v-list-item>
                                    <v-list-item-content class="text-center">
                                        <span>{{ formatPhoneNumber(phone.phone) }} ({{ phone.type }})</span>
                                    </v-list-item-content>
                                </v-list-item>
                            </template>

                            <v-divider></v-divider>
                        </template>
                    </v-list>
                </v-card-text>


                <v-card-actions class="justify-center">
                    <v-btn dark color="error" @click="contactModal = false">
                        Cerrar
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog v-model="emojieModal" content-class="EmojieModal" persistent>
            <v-card>
                <v-card-title class="primary text-center">
                    <v-toolbar-title id="titulocard">Reaccionar a Mensaje</v-toolbar-title>
                </v-card-title>

                <v-card-text>
                    <div class="emoji-container">
                        <VEmojiPicker @select="selectEmoji" />
                    </div>
                </v-card-text>


                <v-card-actions class="justify-center">
                    <v-btn dark color="error" @click="emojieModal = false">
                        Cerrar
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>


        <div class="buble-container-right" :id="idmwhClave">
            <div v-if="MessageType == 'Image'">
                <div v-if="loadingImage == false">
                    <v-row class="justify-end" style="margin:0px;padding:0px;">


                        <p class="text-right user-text">
                            {{ MessageAutor }}
                        </p>
                        <i class="mdi mdi-download download-icon" @click="DescargarMedia('Image')"></i>
                        <v-tooltip top>
                            <template v-slot:activator="{ on, attrs }">

                                <v-btn v-bind="attrs" v-on="on" @click="VerVistos()" icon>
                                    <v-icon class="btnInfo">mdi-information </v-icon>
                                </v-btn>
                            </template>
                            <span>Ver Informaci&oacute;n</span>
                        </v-tooltip>

                    </v-row>

                    <img id="ItemPreview" class="imagePreview buble-text-r" :src="'data:image/png;base64,' + FormattedMediaURL" />
                </div>
                <div class="downloadbutton-container-empty" v-if="loadingImage == true">
                    <v-progress-circular indeterminate color="green"></v-progress-circular>
                </div>
            </div>

            <div v-if="templateImgState == true">
                <img id="ItemPreview" class="imagePreview-template" :src="templateImgUrl" />
            </div>

            <div v-if="MessageType == 'Video'">
                <div v-if="loadingVideo == false">
                    <v-row class="justify-end" style="margin:0px;padding:0px;">


                        <p class="text-right user-text">
                            {{ MessageAutor }}
                        </p>
                        <i class="mdi mdi-download download-icon" @click="DescargarMedia('Video')"></i>
                        <v-tooltip top>
                            <template v-slot:activator="{ on, attrs }">

                                <v-btn v-bind="attrs" v-on="on" @click="VerVistos()" icon>
                                    <v-icon class="btnInfo">mdi-information </v-icon>
                                </v-btn>
                            </template>
                            <span>Ver Informaci&oacute;n</span>
                        </v-tooltip>

                    </v-row>

                    <video controls :name="MessageDate" type="video/mp4" class="videoPreview buble-text-r"
                           :src="'data:video/mp4;base64,' + FormattedMediaURL"></video>
                </div>
                <div class="downloadbutton-container-empty" v-if="loadingVideo == true">
                    <v-progress-circular indeterminate color="green"></v-progress-circular>
                </div>
            </div>

            <div v-if="MessageType == 'Audio'">
                <div style="height: 10px"></div>
                <div v-if="loadingAudio == false">
                    <v-row class="justify-end" style="margin:0px;padding:0px;">


                        <p class="text-right user-text">
                            {{ MessageAutor }}
                        </p>
                        <v-tooltip top>
                            <template v-slot:activator="{ on, attrs }">

                                <v-btn v-bind="attrs" v-on="on" @click="VerVistos()" icon>
                                    <v-icon class="btnInfo">mdi-information </v-icon>
                                </v-btn>
                            </template>
                            <span>Ver Informaci&oacute;n</span>
                        </v-tooltip>

                    </v-row>

                    <audio class="buble-text-r" controls :src="'data:audio/wav;base64,' + FormattedMediaURL"></audio>
                </div>
                <div class="downloadbutton-container-empty" v-if="loadingAudio == true">
                    <v-progress-circular indeterminate color="green"></v-progress-circular>
                </div>
            </div>

            <div v-if="MessageType == 'Document'">
                <div style="height: 10px"></div>
                <v-row class="justify-end" style="margin:0px;padding:0px;">


                    <p class="text-right user-text">
                        {{ MessageAutor }}
                    </p>
                    <v-tooltip top>
                        <template v-slot:activator="{ on, attrs }">

                            <v-btn v-bind="attrs" v-on="on" @click="VerVistos()" icon>
                                <v-icon class="btnInfo">mdi-information </v-icon>
                            </v-btn>
                        </template>
                        <span>Ver Informaci&oacute;n</span>
                    </v-tooltip>

                </v-row>

                <v-row>
                    <v-col cols="8" md="9">
                        <p class="buble-text-docs">{{ AttachFileName }}</p>
                    </v-col>
                    <v-col cols="4" md="3">
                        <div class="downloadbutton-container buble-text-r" v-if="loadingDoc == false">
                            <i class="mdi mdi-download download-docsIcon" @click="DescargarMedia('Document')"></i>
                        </div>
                        <div class="downloadbutton-container-empty" v-if="loadingDoc == true">
                            <v-progress-circular indeterminate color="green"></v-progress-circular>
                        </div>
                    </v-col>
                </v-row>
            </div>
            <div v-if="MessageType == 'Contacts'">
                <p class="text-right" style="margin-bottom: -0.5vh !important;">
                    <v-tooltip top>
                        <template v-slot:activator="{ on, attrs }">

                            <v-btn v-bind="attrs" v-on="on" @click="VerVistos()" icon>
                                <v-icon class="btnInfo">mdi-information </v-icon>
                            </v-btn>
                        </template>
                        <span>Ver Información</span>
                    </v-tooltip>


                </p>
                <v-row align="center" style="margin-top: 1px; margin-right: 1px;">
                    <v-avatar color="grey darken-1" size="36" class="mr-2">
                        <v-icon color="white">mdi-account</v-icon>
                    </v-avatar>
                    <p class="buble-text">{{ formatearContact(MessageText) }}</p>
                </v-row>




                <!--Botón que ocupa todo el ancho-->
                <v-btn block text color="primary" class="mt-2" @click="handleVerClick(MessageText)">
                    VER
                </v-btn>

            </div>

            <div v-if="MessageType == ''">
                <v-row class="justify-end" style="margin:0px;padding:0px;">


                    <p class="text-right user-text">
                        {{ MessageAutor }}
                    </p>
                    <v-tooltip top>
                        <template v-slot:activator="{ on, attrs }">

                            <v-btn v-bind="attrs" v-on="on" @click="VerVistos()" icon>
                                <v-icon class="btnInfo">mdi-information </v-icon>
                            </v-btn>
                        </template>
                        <span>Ver Informaci&oacute;n</span>
                    </v-tooltip>

                </v-row>

                <p class="buble-text text-right buble-text-r" v-html="MessageText"></p>



            </div>
            <!-- Emoji en la esquina inferior derecha -->
            <span :class="{ 'emoji-bottom-right': mwhEmoji !== '' }">{{ mwhEmoji }}</span>
            <span @click="handleEmojiClick" :class="{ 'emoji-bottom-right1': mwhEmojiAusa !== '' }">{{ mwhEmojiAusa }}</span>
            <div id="textbox-2">
                <p class="alignleft time-text">{{ MessageDate }}</p>
                <p class="alignright time-text">
                    <i v-if="MessageStatus == 'queued'" class="mdi mdi-clock"></i>
                    <i v-if="MessageStatus == 'error'" class="mdi mdi-close-circle"></i>
                    <i v-if="MessageStatus == 'Sent'" class="mdi mdi-check"></i>
                    <i v-if="MessageStatus == 'delivered'" class="mdi mdi-check-all"></i>
                    <i v-if="MessageStatus == 'seen'" class="mdi mdi-check-all blue-icon"></i>
                </p>
            </div>
            <!-- Botón de Emoji alineado a la derecha -->
            <v-btn icon class="emoji-button" @click="toggleEmojiPanel()">
                <v-icon class="mdi mdi-emoticon" style="font-size: 1.4em; color: gray;"></v-icon>
            </v-btn>
        </div>
    </div>
</template>

<script>
    import { mapGetters, mapState, mapMutations } from "vuex";
    import * as moment from "moment";
    import WhatsappService from '@/services/Whatsapp/Whatsapp.service.js';
    import { VEmojiPicker } from "v-emoji-picker";
    import { parsePhoneNumber } from "awesome-phonenumber";
    export default {
        components: {
            VEmojiPicker
        },
    data() {
    return {
    formattedMediaURL: "",
    mapLat: "",
    mapLong: "",
    RenderMap: false,
    loadingDoc: true,
    loadingImage: true,
    loadingVideo: true,
    loadingAudio: true,

    templateImgState: false,
    templateImgUrl: "",

    ReplyText: "",
    vistoModal: false,
    usuariosVisto: [],
        loadingModal: false,
        emojieModal: false,
        phones: [],
        contactModal: false,
    };
    },
    props: [
    "MessageText",
    "MessageDate",
    "MessageAutor",
    "MessageStatus",
    "MessageType",
    "MediaURL",
    "AttachFileName",
    "AttachFileFormat",
    "AmazonBackupStatus",
    "ReplyId",
    "localIndex",
    "FormattedMediaURL",
    "idBubble",
    "ntclave",
        "idmwhClave",
        "mwhEmoji",
        "mwhEmojiAusa",
        "phoneNumber"
    ],
        mounted() {
    this.formattedMediaURL = this.FormattedMediaURL;
    this.CheckMediaURL();
    //console.log("EL TEXTO: ", this.MessageText, this.MessageType);
    },
    beforeUnmount() {


    this.MessageText = null;
    this.MessageDate = null;
    this.MessageAutor = null;
    this.MediaURL = null;
    this.AttachFileName = null;
    this.AttachFileName = null;
    this.AttachFileFormat = null;
    this.Latitud = null;
    this.Longitud = null;
    this.AmazonBackupStatus = null;
    this.ReplyId = null;
    this.localIndex = null;
    },
    computed: {
    ...mapState({ drawer: state => state.drawer }),
    ...mapState(['domain', 'informationPage']),
    DRAWER_STATE: {
    get() {
    return this.drawer
    },
    },
    },
        methods: {
            formatPhoneNumber(number) {
                // Asegurarnos de que el número es un string
                number = number.toString();

                // Validar que tenga al menos 12 dígitos
                if (number.length !== 13) {
                    throw new Error("El número debe tener exactamente 12 dígitos.");
                }

                // Aplicar el formato +521 61 2222 2208
                return `+${number.substring(0, 3)} ${number.substring(3, 5)} ${number.substring(5, 9)} ${number.substring(9)}`;
            },
            handleVerClick(value) {

                try {
                    this.phones = JSON.parse(value); // Convierte la cadena JSON a un objeto
                    this.contactModal = true;
                } catch (e) {
                    console.error("Error al parsear el JSON:", e);
                }
                this.contactModal = true;


            },
            formatearContact(value) {
                // Convertir el string a JSON
                let jsonValue = JSON.parse(value);
                if (jsonValue.length > 1) {
                    // Obtener el nombre del primer contacto
                    let firstName = jsonValue[0].name;
                    let total = jsonValue.length - 1;
                    return firstName + " y " + total.toString() + " más";
                }
                else {
                    let firstName = jsonValue[0].name;
                    return firstName;
                }
            },
            async handleEmojiClick() {

                let number = this.phoneNumber.twhTelefono;
                number = number.replace("+", "");

                let formattedNumber = this.formatNumber(this.phoneNumber.twhTelefono);
                formattedNumber = formattedNumber.replace(/ /g, "");
                formattedNumber = formattedNumber.replace("+", "");

                let response = await WhatsappService.ReactToMessage(
                    this,
                    "",
                    number,
                    formattedNumber,
                    this.idBubble
                );

                this.$emit("updateEmojie", "", this.idmwhClave);


            },
            toggleEmojiPanel() {
                this.emojieModal = true;
            },
            async selectEmoji(emoji) {

                this.emojieModal = false;

                let auxText = emoji.data;
                let number = this.phoneNumber.twhTelefono;
                number = number.replace("+", "");

                let formattedNumber = this.formatNumber(this.phoneNumber.twhTelefono);
                formattedNumber = formattedNumber.replace(/ /g, "");
                formattedNumber = formattedNumber.replace("+", "");

                let response = await WhatsappService.ReactToMessage(
                    this,
                    auxText,
                    number,
                    formattedNumber,
                    this.idBubble
                );

                this.$emit("updateEmojie", auxText, this.idmwhClave);
            },
            formatNumber(number) {
                const pn = parsePhoneNumber(number);
                let formatted = pn.getNumber("international");
                return formatted;
            },

    CheckMediaURL() {

    if (this.MediaURL != "") {
    this.ObtenerMediaURL(this.MediaURL, this.MessageType);

    }
    if (this.MessageType == "Location") {
    this.RenderizaMapa();
    }
    if (this.MessageType == "Reply") {
    this.BuscaTextoRespuesta();
    }

    },

    EmitMediaDataToMessages(index, data) {
    this.$emit("mediaURLEmitWatcher", index, data);
    },

    async ObtenerMediaURL(mediaURL, contentType) {

    if (this.FormattedMediaURL == "") {
    switch (contentType) {
    case "Image":
    this.loadingImage = true;

    if (this.AmazonBackupStatus == true) {

    let responseS3 = await WhatsappService.ObtenerMultimediaAmazon(this,
    mediaURL,
    this.AttachFileName
    );

    await this.EmitMediaDataToMessages(
    this.localIndex,
    responseS3.data
    );
    this.loadingImage = false;

    this.formattedMediaURL = responseS3.data;

    } else {
    let response = await WhatsappService.ObtenerContenidoMultimedia(this,
    mediaURL
    );

    if (response[0].value.error == true) {
    return "";
    }
    else {
    await this.EmitMediaDataToMessages(
    this.localIndex,
    response[0].value.msg
    );

    this.formattedMediaURL = response[0].value.msg;

    this.loadingImage = false;

    }


    }

    break;

    case "Video":
    this.loadingVideo = true;
    if (this.AmazonBackupStatus == true) {
    let responseS3Video = await WhatsappService.ObtenerMultimediaAmazon(this,
    mediaURL,
    this.AttachFileName
    );
    await this.EmitMediaDataToMessages(
    this.localIndex,
    responseS3Video.data
    );

    this.formattedMediaURL = responseS3Video.data;
    this.loadingVideo = false;
    } else {
    let responseVideo = await WhatsappService.ObtenerContenidoMultimedia(this,
    mediaURL
    );
    if (responseVideo[0].value.error == true) {
    return "";
    } else {

    await this.EmitMediaDataToMessages(
    this.localIndex,
    responseVideo[0].value.msg
    );
    this.formattedMediaURL = responseVideo[0].value.msg
    this.loadingVideo = false;

    }
    }
    break;

    case "Audio":
    this.loadingAudio = true;
    if (this.AmazonBackupStatus == true) {
    let responseS3Audio = await WhatsappService.ObtenerMultimediaAmazon(this,
    mediaURL,
    this.AttachFileName
    );
    await this.EmitMediaDataToMessages(
    this.localIndex,
    responseS3Audio.data
    );

    this.formattedMediaURL = responseS3Audio.data;
    this.loadingAudio = false;
    } else {// de facebook

    let response = await WhatsappService.ObtenerContenidoMultimedia(this,
    mediaURL
    );

    if (response[0].value.error == true) {
    return "";
    }
    else {
    await this.EmitMediaDataToMessages(
    this.localIndex,
    response[0].value.msg
    );
    this.formattedMediaURL = response[0].value.msg;
    this.loadingAudio = false;

    }
    }
    break;

    case "Document":
    this.loadingDoc = true;
    if (this.AmazonBackupStatus == true) {
    let responseS3Doc = await WhatsappService.ObtenerMultimediaAmazon(this,
    mediaURL,
    this.AttachFileName
    );
    await this.EmitMediaDataToMessages(
    this.localIndex,
    responseS3Doc.data
    );

    this.formattedMediaURL = responseS3Doc.data;
    this.loadingDoc = false;
    } else {
    let response = await WhatsappService.ObtenerContenidoMultimedia(
    mediaURL
    );

    if (response[0].value.error == true) {
    return "";
    }
    else {
    await this.EmitMediaDataToMessages(
    this.localIndex,
    response[0].value.msg
    );
    this.formattedMediaURL = response[0].value.msg;
    this.loadingDoc = false;

    }
    }
    break;

    default:
    console.log(
    "Unssuported Media Type Detected And Message Index: ",
    this.localIndex
    );
    break;
    }
    } else {
    this.loadingImage = false;
    this.loadingVideo = false;
    this.loadingAudio = false;
    this.loadingDoc = false;

    }
    },

    RenderizaMapa() {
    this.mapLat = this.Latitud;
    this.mapLong = this.Longitud;
    this.RenderMap = true;
    },

    async BuscaTextoRespuesta() {
    let responsebody = await WhatsappService.ObtenerTextoRespuesta(
    this.ReplyId
    );
    this.ReplyText = responsebody.data[0].mwhBody;
    },
    async VerVistos() {

    this.vistoModal = true;
    this.loadingModal = true;
    let datos = await WhatsappService.ObtenerVistos(this, this.idmwhClave);
    this.loadingModal = false;

    this.usuariosVisto = datos;

    },
    DescargarMedia(type) {
    switch (type) {
    case "Image":
    this.DescargarImagen(this.MessageDate);
    break;
    case "Video":
    this.DescargarVideo(this.MessageDate);
    break;
    case "Document":
    this.DescargarDocumento(this.MessageDate);
    break;
    }
    },

    DescargarDocumento(filename) {
    const linkSource = `data:application/pdf;base64,${this.formattedMediaURL
    }`;
    const downloadLink = document.createElement("a");
    const file = "WhatsappDocument" + filename;
    downloadLink.href = linkSource;
    downloadLink.download = file;
    downloadLink.click();
    },

    DescargarVideo(filename) {
    const linkSource = `data:video/mp4;base64,${this.formattedMediaURL}`;
    const downloadLink = document.createElement("a");
    const file = "WhatsappVideo" + filename;
    downloadLink.href = linkSource;
    downloadLink.download = file;
    downloadLink.click();
    },

    DescargarImagen(filename) {


    const linkSource = `data:image/png;base64,${this.formattedMediaURL}`;

    const downloadLink = document.createElement("a");
    const file = "WhatsappImage" + filename;
    downloadLink.href = linkSource;
    downloadLink.download = file;
    downloadLink.click();
    },
    },
    };
</script>

<style>

    .VistoModal {
        width: 25vw !important;
        height: auto;
        min-height: 30vh;
        max-height: 80vh !important;
        scrollbar-width: thin;
    }
    .EmojieModal {
        width: 29vw !important;
        height: auto;
        min-height: 30vh;
        max-height: 80vh !important;
        scrollbar-width: thin;
    }

    .emoji-container {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 100%;
    }

        .emoji-container .v-emoji-picker {
            width: 100% !important;
            max-width: none !important;
        }
    @media screen and (max-width: 1200px) {


    .VistoModal {
    width: 50% !important;
    }
        .EmojieModal {
            width: 50% !important;
        }

    }

    @media screen and (max-width: 767px) {


    .VistoModal {
    width: 80% !important;
    }
        .EmojieModal {
            width: 80% !important;
        }

    }


    @media screen and (max-width: 500px) {


    .VistoModal {
    width: 100% !important;
    }
        .EmojieModal {
            width: 100% !important;
        }
    }
    .btnCerrar {
    margin-top: 8vh !important;
    margin-bottom: 1vh !important;
    }

    .blue-icon {
    color: #007cc9;
    }

    .imagePreview {
    width: 160px;
    height: auto !important;
    object-fit: fill !important;
    }

    @media screen and (min-width: 700px) {
    .imagePreview {
    width: 180px;
    height: auto !important;
    object-fit: fill !important;
    }
    }
</style>

<style scoped lang="scss">
    .buble-container-right:hover .emoji-button {
        opacity: 1; /* El botón se vuelve visible al pasar el mouse */
        pointer-events: auto; /*Habilitar interacción con el botón */
    }

    .emoji-button {
        position: absolute;
        top: 50%;
        left: -35px;
        transform: translateY(-50%);
        font-size: 1.4em;
        color: gray;
        opacity: 0; /* El botón comienza invisible */
        pointer-events: none; /* El botón no interactúa cuando está invisible */
        transition: opacity 0.3s ease; /* Transición suave */
    }
    .emoji-bottom-right {
        position: absolute;
        bottom: -25px; /* Mueve más abajo el círculo */
        right: 10px; /* Puedes ajustar esto para moverlo más a la derecha */
        width: 35px; /* Ancho del círculo */
        height: 35px; /* Altura del círculo */
        background: #ffffff; /* Fondo blanco */
        border-radius: 50%; /* Hace el contenedor circular */
        border: 2px solid #ddd; /* Borde alrededor del círculo */
        display: flex; /* Centra el emoji */
        align-items: center; /* Centra verticalmente el emoji */
        justify-content: center; /* Centra horizontalmente el emoji */
        font-size: 1.2em; /* Tamaño del emoji */
        box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1); /* Sombra para un efecto más suave */
        pointer-events: none; /* Hace que no sea interactivo */
    }
    .emoji-bottom-right1 {
        position: absolute;
        bottom: -25px;
        left: 46px;
        width: 35px;
        height: 35px;
        background: #bdccf7;
        border-radius: 50%;
        border: 2px solid #bdccf7;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 1.2em;
        box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
        pointer-events: auto; /* Permitir interacción */
        cursor: pointer; /* Indicar que se puede hacer clic */
    }
    .blue-icon {
    color: #007cc9;
    }

    .buble-text {
    margin: 0;
    font-family: "Poppins", sans-serif;
    font-weight: 600;
    word-spacing: 3px;
    font-size: 16px;
    color: #111b21;
    }

    .buble-text-r {
        margin-right: 20px !important;
    }

    .buble-holder-right {
        display: flex;
        justify-content: end;
        margin-bottom: 20px;
    }

    .buble-container-right {
    position: relative;
    background: #d9fdd3;
    border-radius: 0.4em;
    padding: 0px 5px 5px 20px;
    width: auto;
    height: auto;
    max-width: 85%;
    margin-bottom: 10px;

    &:after {
    content: "";
    position: absolute;
    right: 0;
    top: 50%;
    width: 0;
    height: 0;
    border: 0.625em solid transparent;
    border-left-color: #d9fdd3;
    border-right: 0;
    margin-top: -0.625em;
    margin-right: -0.625em;
    }
    }

    .time-text {
    margin: 0;
    margin-top: 10px;
    font-family: "Work Sans", sans-serif;
    font-weight: 400;
    font-size: 12px;
    color: #111b21;
    }

    .user-text {
    margin: 0;
    margin-top: 10px;
    margin-bottom: 5px;
    font-family: "Work Sans", sans-serif;
    font-weight: 400;
    font-size: 12px;
    color: #111b21;
    }

    .icon-format {
    font-size: 14px;
    margin-left: 15px;
    }

    .alignleft {
    float: left;
    }

    .alignright {
    float: right;
    }

    ////NEW YSANCHEZG -----------------------------------------
    .downloadbutton-container {
    width: 35px;
    height: 35px;
    background-color: #4d4d4d;
    text-align: center;
    vertical-align: middle;
    line-height: 35px;
    border-radius: 50%;
    margin-top: 10px;
    }

    .downloadbutton-container-empty {
    width: 35px;
    height: 35px;
    text-align: center;
    vertical-align: middle;
    line-height: 35px;
    border-radius: 50%;
    margin-top: 10px;
    }

    .buble-text {
    margin: 0;
    font-family: "Poppins", sans-serif;
    font-weight: 600;
    word-spacing: 3px;
    font-size: 16px;
    color: #111b21;
    }

    .buble-text-docs {
    margin: 0;
    font-family: "Poppins", sans-serif;
    font-weight: 600;
    word-spacing: 3px;
    font-size: 14px;
    color: #5f5f5f;
    }

    .buble-text-reply {
    margin: 0;
    font-family: "Poppins", sans-serif;
    font-weight: 600;
    word-spacing: 3px;
    font-size: 14px;
    color: #313131;
    }

    .buble-holder-left {
    display: flex;
    justify-content: start;
    margin-bottom: 20px;
    }

    .buble-container-left {
    position: relative;
    background: #ffffff;
    border-radius: 0.4em;
    padding: 10px 20px 10px 30px;
    width: auto;
    min-width: auto;
    max-width: 85% !important;
    margin-bottom: 10px;
    height: auto;
    }

    @media only screen and (max-width: 507px) {
    .buble-container-left {
    position: relative;
    background: #ffffff;
    border-radius: 0.4em;
    padding: 10px 20px 10px 30px;
    width: auto;
    min-width: 220px;
    max-width: 85% !important;
    margin-bottom: 10px;
    height: auto;
    }
    }

    .buble-container-left:after {
    content: "";
    position: absolute;
    left: 0;
    top: 50%;
    width: 0;
    height: 0;
    border: 0.625em solid transparent;
    border-right-color: #ffffff;
    border-left: 0;
    margin-top: -0.625em;
    margin-left: -0.625em;
    }

    .time-text {
    margin: 0;
    margin-top: 10px;
    font-family: "Work Sans", sans-serif;
    font-weight: 400;
    font-size: 12px;
    color: #111b21;
    }

    .imagePreview-template {
    width: 320px !important;
    height: 320px !important;
    object-fit: contain !important;
    }

    .videoPreview {
    width: auto;
    //max-width: 320px !important;
    height: 320px !important;
    }

    .download-icon {
    font-size: 16px;
    color: rgb(26, 26, 26);
    margin-top: 8px;
   
    }

    .download-icon:hover {
        font-size: 16px;
        color: #25d366;
        margin-top: 8px;
    }

    .download-docsIcon {
    font-size: 16px;
    color: white;
    }

    .download-docsIcon:hover {
    font-size: 16px;
    color: #25d366;
    }

    .reply-container {
    background-color: #dddddd;
    padding: 10px 10px 10px 10px;
    margin-bottom: 5px;
    border-radius: 10px;
    }
</style>
